import { render, staticRenderFns } from "./RiChang2.vue?vue&type=template&id=b2d8bc2e&scoped=true&"
import script from "./RiChang2.vue?vue&type=script&lang=js&"
export * from "./RiChang2.vue?vue&type=script&lang=js&"
import style0 from "./RiChang2.vue?vue&type=style&index=0&id=b2d8bc2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d8bc2e",
  null
  
)

export default component.exports